import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { EditEventError, Event, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: EditEventError;
  editEvent(request: Boundaries["editEvent"]["request"]): void;
}

function useEditEvent(event: Identifiable<Event>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditEventRequestPending(event),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditEventRequestSuccess(event),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditEventRequestFailure(event),
    ),
    error: useSelector(() => selector.getEditEventError(event)),
    editEvent: core.editEvent,
  };
}

export { useEditEvent };
